module.exports = "<p>\r\n  You are currently logged in as: {{user?.email}}\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/logged-in-as/logged-in-as.component.html
// module id = ../../../../../src/app/component/logged-in-as/logged-in-as.component.html
// module chunks = main